import { render, staticRenderFns } from "./markdown_editor.vue?vue&type=template&id=210cf8d3"
import script from "./markdown_editor.vue?vue&type=script&lang=js"
export * from "./markdown_editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports